import React, { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgUrl } from "@/utils/format";

/** Visionneuse photo plein écran — clic sur une vignette d'avis.
 * Props: photos (array d'URLs), initialIndex, onClose */
export default function PhotoLightbox({ photos, initialIndex = 0, onClose }) {
  const [index, setIndex] = useState(initialIndex);
  const total = photos?.length || 0;

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + total) % total);
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % total);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, total]);

  if (!total) return null;

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="photo-lightbox"
    >
      <button
        onClick={onClose}
        data-testid="lightbox-close"
        aria-label="Fermer"
        className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 text-white rounded-full p-2.5 transition-colors"
      >
        <X className="w-6 h-6" />
      </button>

      {total > 1 && (
        <button
          onClick={(e) => { e.stopPropagation(); setIndex((i) => (i - 1 + total) % total); }}
          data-testid="lightbox-prev"
          aria-label="Photo précédente"
          className="absolute left-3 sm:left-6 bg-white/10 hover:bg-white/20 text-white rounded-full p-2.5 transition-colors"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
      )}

      <img
        src={imgUrl(photos[index])}
        alt={`Photo ${index + 1} sur ${total}`}
        data-testid="lightbox-image"
        onClick={(e) => e.stopPropagation()}
        className="max-h-[85vh] max-w-[92vw] object-contain rounded-xl shadow-2xl"
      />

      {total > 1 && (
        <button
          onClick={(e) => { e.stopPropagation(); setIndex((i) => (i + 1) % total); }}
          data-testid="lightbox-next"
          aria-label="Photo suivante"
          className="absolute right-3 sm:right-6 bg-white/10 hover:bg-white/20 text-white rounded-full p-2.5 transition-colors"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      )}

      {total > 1 && (
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 text-white/80 text-sm bg-white/10 rounded-full px-3 py-1">
          {index + 1} / {total}
        </div>
      )}
    </div>
  );
}
